<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Customer-wise Due Summary'" />
      <CustomerSummaryReport />
    </div>
    <div class="col-md-12 home-tabs-body"></div>
  </v-row>
</template>

<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import CustomerSummaryReport from "@/components/reports/CustomerSummaryReport.vue";
export default {
  components: { Breadcrumbs, CustomerSummaryReport },
};
</script>
